// extracted by mini-css-extract-plugin
export default {"root":"IconDownload_root__PJT6w"};